import { ComponentProps, JSX } from "solid-js";

import UObject from "@repo/utils/UObject";

import UNumber from "../../../utils/src/UNumber.mjs";
import createDomRect from "../signals/createDomRect";

declare namespace TransitionHeight {
  type Props = UObject.Override<
    ComponentProps<"div">,
    {
      forFade?: boolean;
      style?: JSX.CSSProperties;
    }
  >;
}

function TransitionHeight({
  children,
  style,
  forFade,
  ref,
  ...props
}: D<TransitionHeight.Props>) {
  const containerRect = createDomRect({ only: ["size"] });
  const rect = createDomRect({ only: ["size"] });

  return (
    <div
      ref={(el) => {
        containerRect.ref(el);
        if (typeof ref === "function") ref(el);
      }}
      style={{
        height: `${rect()?.height}px`,
        transition: "0.3s",
        ...(forFade
          ? { position: "relative" }
          : {
              overflow: UNumber.Bounds.includes(
                UNumber.Bounds.fromOffset(
                  (containerRect()?.height || 0) - 2,
                  4
                ),
                rect()?.height || 0
              )
                ? "initial"
                : "hidden",
            }),
        ...style,
      }}
      {...props}
    >
      <div ref={rect.ref}>{children}</div>
    </div>
  );
}

export default TransitionHeight;
